import { render } from "./SoundButton.vue?vue&type=template&id=5250a46b&scoped=true"
import script from "./SoundButton.vue?vue&type=script&lang=ts"
export * from "./SoundButton.vue?vue&type=script&lang=ts"

import "./SoundButton.vue?vue&type=style&index=0&id=5250a46b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5250a46b"

export default script